import styled from 'styled-components';

const DividerWrapper = styled.div`
  display: block;
  width: 100%;
  line-height: 0;
  margin: 0;
  padding: 0;
  overflow: hidden;
`;

const DividerSvg = styled.svg`
  display: block;
  width: 100%;
  height: 60px;

  @media (min-width: 768px) {
    height: 80px;
  }
`;

const WaveDivider = ({ topColor = '#faf7f2', bottomColor = '#2e3328' }) => {
  return (
    <DividerWrapper style={{ backgroundColor: bottomColor }}>
      <DividerSvg
        viewBox="0 0 1440 80"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0,0 L0,55 Q360,80 720,55 Q1080,30 1440,55 L1440,0 Z"
          fill={topColor}
        />
      </DividerSvg>
    </DividerWrapper>
  );
};

export default WaveDivider;
